module.exports = __webpack_public_path__ + "assets/1ac511f2c5aff1835dea0e11c86e36be.png";